module.exports = __webpack_public_path__ + "media/transfere.dad07ff7.mp3";